import React from 'react';

class WizardItemDropDown extends React.Component {

	constructor(props) {

		super(props);
		this.state = {
			selected: "defaultVal",
			value: "defaultVal"
		};

		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(e) {
		this.setState({ value: e.target.value });
		this.props.submitAnswer(e.target.value);
	}

	render() {
		const useTag = '<use xlink:href="/dist/svgsprite/icons.svg#Checkmark_16x16"/>';
		return (
			<div className="wizard-item wizard-item__select">
				{this.props.data.DropDownListPreHeader &&
					<label htmlFor={"ddl-" + this.props.data.Id}>{this.props.data.DropDownListPreHeader}</label>
				}
				<select name="" id={"ddl-" + this.props.data.Id} value={this.state.value} onChange={this.handleChange}>
					<option disabled="disabled" value="defaultVal" className="option" >{this.props.data.SelectOptionHeader}</option>
					{
						this.props.data.Options.map(
							(option, idx) => {
								return (
									<option className="option" value={option.Id} key={idx}>{option.Header}</option>
								)
							}
						)
					}
				</select>
			</div>
		)
	}
}

export default WizardItemDropDown;